import { useQuery } from "@tanstack/react-query";
import CustomerReservationsClient from "../../clients/CustomerReservationsClient";

// Separate data fetching logic that can be used by both the hook and prefetch
const fetchOrderDetails = async (orderId, userCommonId) => {
  const { data } = await CustomerReservationsClient.fetchOrderDetails(
    orderId,
    userCommonId,
    false,
    "en",
    null
  );
  return data;
};

export const useOrder = (userCommonId, orderId) => {
  const isValidOrderId =
    orderId !== null &&
    orderId !== undefined &&
    orderId !== "" &&
    orderId !== "null";

  return useQuery({
    queryKey: ["order", { orderId }],
    queryFn: () => fetchOrderDetails(orderId, userCommonId),
    enabled: isValidOrderId && !!userCommonId,
    staleTime: 60 * 1000,
    retry: 2,
  });
};

// Separate function for prefetching that doesn't use hooks
export const prefetchOrder = async (queryClient, userCommonId, orderId) => {
  const isValidOrderId =
    orderId !== null &&
    orderId !== undefined &&
    orderId !== "" &&
    orderId !== "null";
  if (isValidOrderId) {
    return await queryClient.prefetchQuery({
      queryKey: ["order", { orderId }],
      queryFn: () => fetchOrderDetails(orderId, userCommonId),
      staleTime: 60 * 1000,
    });
  }
};
